import { FullScreenFrame } from '../../../modules/system/FullScreenFrame';

/**
 * Shell-Splash: shown while MSAL signs the user in (App, RequireAuth, IdentityAction): the brand mark, "Orbital Watch",
 * "Signing you in…" and an indeterminate track.
 */
export function SplashScreen(props: { text?: string }) {
    return (
        <FullScreenFrame title="Orbital Watch" role="status">
            <p>{props.text ?? 'Signing you in…'}</p>
            <div className="ark-fullscreen-track" aria-hidden="true" />
        </FullScreenFrame>
    );
}
